import { useContext } from "react";
import GTMContext from "./GTMContext";

const useGTM = () => useContext(GTMContext);

export default useGTM;
